import React, { Component } from 'react';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Certificate from './components/Certificate';
import Skills from './components/Skills';
import Biography from './components/Biography';

class App extends Component {
  render() {

    const person = {
      avatar: 'https://media.licdn.com/mpr/mpr/shrinknp_200_200/AAEAAQAAAAAAAAaaAAAAJDM2NDA0ZTk1LTI3OWEtNGIzYS05MDJiLTUxYzFmMTE4N2I4Ng.jpg',
      name: 'Sarawut Kodkeaw',
      profession: 'FrontEnd Developer',
      biography: `I'm an experienced website developer. I have abilities to work as Front-end developer. My goal is focus on develop high performance applications and websites which can commercialise and attract users by using modern technologies and concern about web accessibility and usability. I enjoy functional programming and technologies like ReactJS, React Native and Redux. Also, I have background knowledge from Backend Development and prompt to understand backend process. I learn and adapt quickly to different situations, I am positive, trustworthy and eager to collaborate with different teams.`,
      address: 'Bangkok, Thialand',
      social: [
        {name: 'github', url: 'https://github.com/sirguys'},
        {name: 'linkedin', url: 'https://www.linkedin.com/in/sarawut-kodkeaw-231011114/'}
      ],
      experience: [
        {jobTitle: 'Front-End Developer', company: 'VCK Life Co.,Ltd', startDate: 'Jan 2017', endDate: 'Present', jobDescription: 'Create and develop web site by written on HTML, CSS with precompiler language (SASS/SCSS) and JS code, to make it meet the standard, modern and responsive website by apply with new technology such as Bootstrap, Semantic UI and React front-end framework'},
        {jobTitle: 'Web Developer', company: 'Appdever', startDate: 'Oct 2015', endDate: 'Dec 2016', jobDescription: `Develop a website using HTML5/CSS3/JavaScript as front-end and using Laravel5 as back-end. Develop hybrid mobile apps or web apps using Framework7. Modify CMS Wordpress as request from customer.`},
      ],
      education: [
        {degree: 'SCIENCE PROGRAM IN INFORMATION TECHNOLOGY', institution: 'DPU', startDate: '2011', endDate: '2015', description: 'GPA: 3.15'},
      ],
      certificate: [
        {name: 'Powering Up With React', institution: 'Code School', date: '2016', description: 'Discover how React can help you take control of your UI code with composable user interfaces.' },
        {name: 'Real Time Web with Node.js', institution: 'Code School', date: '2016', description: 'Discover how the Node framework can help you write server-side code and build lightweight, scalable network applications.' }
      ],
      skills: [
        {name: 'HTML5', percentage: '80%'},
        {name: 'CSS - SASS/SCSS', percentage: '80%'},
        {name: 'JavaScript ES6', percentage: '65%'},
        {name: 'React', percentage: '60%'},
        {name: 'Redux', percentage: '40%'},
        {name: 'Node.js', percentage: '40%'},
        {name: 'Photoshop', percentage: '70%'},
        {name: 'Illustrator', percentage: '40%'},
        {name: 'Sketch App', percentage: '40%'},
      ]
    };

    return (
      <header>
        <div className='wrapper'>
          <div className='sidebar'>
            <About
              avatar={person.avatar}
              name={person.name}
              profession={person.profession}
              biography=''
              address={person.address}
              social={person.social} />
          </div>

          <div className='content-wrapper'>
              <div className='content'>
                <Biography biography={person.biography} />
                <Experience experience={person.experience} />
                <Education education={person.education} />
                <Certificate certificate={person.certificate} />
                <Skills skills={person.skills} />
              </div>
          </div>

        </div>
      </header>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js